document.addEventListener("DOMContentLoaded", function () {
    const nav = document.querySelectorAll(".main-nav__item-index");
    const megaHover = document.querySelectorAll(".child-link-list-hover");
    
    nav.forEach( n => {
        n.addEventListener("mouseenter", function(el) {
        const menuIndex = el.target;
        let num = menuIndex.dataset.index;
        let collectionImage = document.querySelector(`.my-mega-menu-collection-image--${num}`);
        let productImage = document.querySelector(`.my-mega-menu-product-image--${num}`);
        let hoveredCollectionImage = `${menuIndex.dataset.menuImageOne}`;
        let hoveredProductImage = `${menuIndex.dataset.menuImageTwo}`;
        collectionImage.src = hoveredCollectionImage;
        productImage.src = hoveredProductImage;
        
            megaHover.forEach( (mm) => {
                mm.addEventListener("mouseenter", function(e) {
                    const hovered = e.target;
                    let collectionImage = document.querySelector(`.my-mega-menu-collection-image--${num}`);
                    let productImage = document.querySelector(`.my-mega-menu-product-image--${num}`);
                    let hoveredCollectionImage = `${hovered.dataset.collectionImage}`;
                    let hoveredProductImage = `${hovered.dataset.productImage}`;
                    collectionImage.src = hoveredCollectionImage;
                    productImage.src = hoveredProductImage;
                });
            });

        });

    });
        
});
